import Text from 'lib/common/components/Text';

const ErrorMessage = ({ message }: { message: string }) => (
  <Text type="small" color="danger">
    {message}
  </Text>
);

export default ErrorMessage;
